if (!customElements.get('discovery-slider')) {
  customElements.define('discovery-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('.discovery__track');
      this.slides = [...this.querySelectorAll('.discovery__slide')];
      this.steps = [...this.querySelectorAll('[data-slide]')];
      this.index = -1;
      this.requestedIndex = null;
      if (!this.track || !this.slides.length) return;
      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-slide]');
        const arrow = event.target.closest('[data-direction]');
        if (step) this.go(Number(step.dataset.slide));
        if (arrow) this.go(((this.requestedIndex ?? this.index) + Number(arrow.dataset.direction) + this.slides.length) % this.slides.length);
      }, { signal });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.setActive(Math.round(this.track.scrollLeft / this.track.clientWidth)));
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => { this.requestedIndex = null; }, 150);
      }, { signal, passive: true });
      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('.discovery__slide');
        const index = this.slides.indexOf(slide);
        if (index >= 0) this.go(index);
      }, { signal });
      this.setActive(0);
    }
    go(index) {
      this.requestedIndex = index;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: index * this.track.clientWidth, behavior: reduced ? 'instant' : 'smooth' });
    }
    setActive(index) {
      const next = Math.max(0, Math.min(index, this.slides.length - 1));
      if (next === this.index) return;
      this.index = next;
      this.steps.forEach((step, i) => i === this.index ? step.setAttribute('aria-current', 'true') : step.removeAttribute('aria-current'));
      this.slides.forEach((slide, i) => { slide.inert = i !== this.index; });
      const status = this.querySelector('[data-slide-status]');
      if (status) status.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      cancelAnimationFrame(this.frame);
      clearTimeout(this.scrollTimer);
    }
  });
}
